export class Controller {

    /** @ngInject */
    constructor(Alert, DestructiveOperationModal) {
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    $onInit() {
        this.isHardTokenUser = this.account.isSecondaryDeviceSession;
        this.userDevices = this.devices.userDevices;
        this.hardTokens = this.devices.hardTokens;
    }

    showDeleteDeviceDP(id) {
        this.DestructiveOperationModal({
            titleKey: 'device_management.delete_modal_header',
            textKey: 'device_management.delete_modal_content',
            http: {method: 'DELETE', url: `app/rest/device_management/${id}`}
        }).then(() => {
            const index = this.userDevices.findIndex(d => d.id === id);
            this.userDevices.splice(index, 1);
            this.Alert('success', 'device_management.messages.delete');
        });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/device-management/device-management.controller.js